import Dialog from '@components/atoms/dialog/dialog';
import { NegotiationModal } from '@components/organisms/negotiation/negotiation-modal/negotiation-modal';
import { NegotiationDialogStyles } from '@constants/negotiation';
import { useNegotiation } from '@context/negotiation.context';
import { useGetNegotiationById } from '@hooks/negotiations/useNegotationQueries';
import { useEffect, useState } from 'react';

interface SellingOffersNegotiationDialogProps {
  negotiationId: string | null;
  setNegotiationId: (id: string | null) => void;
  setHasPopupNegotiationError: (hasError: boolean) => void;
}

const SellingOffersParamDialog: React.FC<SellingOffersNegotiationDialogProps> = ({
  negotiationId,
  setNegotiationId,
  setHasPopupNegotiationError,
}) => {
  const [openNegotiationModal, setOpenNegotiationModal] = useState<boolean>(false);
  const { negotiation } = useNegotiation();

  useGetNegotiationById({
    negotiationId,
    withEvents: true,
    enabled: !!negotiationId,
    onErrorCallback: () => {
      setHasPopupNegotiationError(true);
    },
  });

  const closeNegotiationModal = () => {
    setOpenNegotiationModal(false);
    setNegotiationId(null);
  };

  useEffect(() => {
    if (!negotiationId) {
      return;
    }
    if (negotiation && String(negotiation.id) === negotiationId) {
      setOpenNegotiationModal(true);
    }
  }, [negotiationId, negotiation]);

  return (
    <Dialog
      closeDialog={closeNegotiationModal}
      isOpen={openNegotiationModal}
      hasCloseIcon
      styles={{
        content: NegotiationDialogStyles,
      }}
    >
      {(modalDialogTitleId) => (
        <NegotiationModal
          onClose={closeNegotiationModal}
          trackingFrom="TODO"
          modalDialogTitleId={modalDialogTitleId}
        />
      )}
    </Dialog>
  );
};

export default SellingOffersParamDialog;
